// Buffer synthesis uses the shared subset of browser and WeChat WebAudio.
// No oscillator/AudioWorklet dependency: WeChat can loop AudioBufferSourceNodes.
export class EngineSound {
  constructor(createContext){this.createContext=createContext;this.enabled=true;this.status='idle';this.nodes=[];this.context=null;this.suspended=false;this.error=null;}
  unlock(){
    if(!this.context){
      try{
        const c=this.createContext();if(!c)throw new Error('WebAudio unavailable');this.context=c;
        this.master=c.createGain();this.master.gain.value=0;this.master.connect(c.destination);
        for(let layer=0;layer<3;layer++){
          const rate=24000, duration=layer===2?1:.2,buffer=c.createBuffer(1,rate*duration,rate),samples=buffer.getChannelData(0);
          let seed=17;
          for(let i=0;i<samples.length;i++){
            const t=i/rate;seed=(seed*16807)%2147483647;
            samples[i]=layer===2?(seed/2147483647*2-1)*.35:layer===0?(Math.sin(2*Math.PI*160*t)+.45*Math.sin(2*Math.PI*320*t)+.22*Math.sin(2*Math.PI*480*t))*.4:Math.sin(2*Math.PI*320*t)*(.5+.5*Math.sin(2*Math.PI*40*t))*.5;
          }
          const source=c.createBufferSource(),gain=c.createGain();source.buffer=buffer;source.loop=true;gain.gain.value=0;source.connect(gain);gain.connect(this.master);source.start();this.nodes.push({source,gain});
        }
        this.status='ready';
      }catch(e){for(const n of this.nodes){try{n.source.stop();}catch{}}this.nodes=[];this.error=String(e);this.status='unavailable';this.master?.disconnect?.();this.context?.close?.();this.context=null;return;}
    }
    this.suspended=false;
    try{const result=this.context.resume?.();result?.catch?.(e=>{this.error=String(e);this.status='suspended';});}catch(e){this.error=String(e);}
  }
  setEnabled(value){this.enabled=value;if(value)this.unlock();else this.silence();}
  silence(){if(this.master)this.master.gain.value=0;}
  suspend(){this.suspended=true;this.silence();try{this.context?.suspend?.();}catch{/* silence is sufficient */}}
  update(v,active){
    if(!this.context||!this.master||this.status!=='ready')return;
    try {
    const live=active&&this.enabled&&!this.suspended;
    this.master.gain.value=live?.34:0;
    if(!live)return;
    const rpm=Math.max(0,v.rpm),base=rpm/4800;
    for(let i=0;i<2;i++){const n=this.nodes[i];n.source.playbackRate.value=Math.min(2,Math.max(.01,base*(i?1.004:1)));n.gain.gain.value=rpm>30?(i?.18+.2*v.load:.26+.35*v.throttle)*(v.cut?.35:1):0;}
    this.nodes[2].gain.gain.value=Math.min(.32,v.speed/220)+v.throttle*.025;
    }catch(error){this.error=String(error);this.status='unavailable';this.silence();}
  }
  cue(kind){
    if(!this.enabled||this.suspended||!this.context||this.status!=='ready')return;
    try{
      const c=this.context,len=kind==='grind'?.16:kind==='stall'?.25:.065,buffer=c.createBuffer(1,Math.ceil(24000*len),24000),d=buffer.getChannelData(0);
      for(let i=0;i<d.length;i++){const t=i/24000;d[i]=Math.sin(t*2*Math.PI*(kind==='grind'?140:kind==='stall'?65:110))*Math.exp(-t*30)*.5;}
      const source=c.createBufferSource();source.buffer=buffer;source.connect(this.master);source.start();
    }catch(e){this.error=String(e);}
  }
  diagnostics(){return {status:this.status,state:this.context?.state||null,nodes:this.nodes.length,enabled:this.enabled,error:this.error};}
  dispose(){this.silence();for(const n of this.nodes){try{n.source.stop();}catch{}}this.nodes=[];this.context?.close?.();}
}
